var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVideoBg)?_c('div',{staticClass:"duration",on:{"click":function($event){_vm.onClick();_vm.report('durationSetting');_vm.report('durationSetting2')}}},[_c('div',[_vm._v("\n    视频时长："+_vm._s(_vm.startFormat)+" - "+_vm._s(_vm.endFormat)+" "+_vm._s(_vm.durationFormat && '/')+" "+_vm._s(_vm.durationFormat)+"\n  ")])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3e3bd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tool/bgSettingBtn/duration.vue
// module id = null
// module chunks = 